const FONT_WAIT_MS = 4000;

let listPromise = null;
const loaded = new Map();

// The Google Fonts catalogue the console offers for font pickers ([{ family }, ...]).
export function getGoogleFonts(api) {
	return listPromise ||= api.get('googleFonts').catch(e => {
		listPromise = null;
		throw e;
	});
}

// Adds the family's stylesheet once per page. Resolves when the font is ready to draw with (or after a timeout, or if it
// can't be loaded), so canvas rendering can wait for it.
export function loadGoogleFont(family) {
	if(!family) return Promise.resolve();
	if(!loaded.has(family)) {
		loaded.set(family, new Promise(resolve => {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = `https://fonts.googleapis.com/css?${new URLSearchParams({ family })}`;
			link.onload = () => document.fonts.load(`16px "${family}"`).then(resolve, resolve);
			link.onerror = () => resolve();
			document.head.appendChild(link);
			setTimeout(resolve, FONT_WAIT_MS);
		}));
	}
	return loaded.get(family);
}
